import businessesService from '@/services/businessesService'
import arraysAndJsonsHelpers from '@/libs/arraysAndJsonsHelpers'

const state = {
  businesses: [],
  business: {},
  // This variables shouldn´t be in the storage
  // I must find a way to change them in the father component (AppBusiness)
  loadingBusiness: false,
  loadingBusinesses: true,
  paginationBusinesses: {},
  totalBusinesses: 0,
  selectedBusiness: {},
  search: '',
  advancedSearch: {
    location: [],
    otherLabelsSelected: [],
    otherLabels: {},
    categories: [],
    segments: []
  }
}

const mutations = {
  'CLEAR_ADVANCED_SEARCH' (state) {
    state.advancedSearch.location = []
    state.advancedSearch.otherLabelsSelected = []
    state.advancedSearch.otherLabels = {}
    state.advancedSearch.categories = []
    state.advancedSearch.segments = []
  },
  'CLEAR_OTHER_LABELS' (state) {
    state.advancedSearch.otherLabels = {}
  },
  'SET_BUSINESSES' (state, businesses) {
    state.businesses = businesses
  },
  'SET_BUSINESS' (state, business) {
    state.business = business
  },
  // These mutations belong to the variables that shouldn´t be in the storage
  'SET_TOTAL_BUSINESSES' (state, totalBusinesses) {
    state.totalBusinesses = totalBusinesses
  },
  'SET_LOADING_BUSINESS' (state, status) {
    state.loadingBusiness = status
  },
  'SET_LOADING_BUSINESSES' (state, status) {
    state.loadingBusinesses = status
  },
  'SET_PAGINATION_BUSINESSES' (state, pagination) {
    state.paginationBusinesses = pagination
  },
  'SET_SELECTED_BUSINESS' (state, business) {
    state.selectedBusiness = business
  },
  'SET_SEARCH_BUSINESSES' (state, search) {
    state.search = search
  }
}

const actions = {
  addContact (vuexContext, data) {
    return businessesService.addContact(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      data)
  },
  async deleteContact (vuexContext, data) {
    await businessesService.deleteContact(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      data
    )
    return true
  },
  async newBusiness (vuexContext, data) {
    await businessesService.newBusiness(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      data
    )
    vuexContext.dispatch('getBusinesses')
    return true
  },
  async getBusiness (vuexContext, businessId) {
    const response = await businessesService.getBusiness(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      businessId
    )
    vuexContext.commit('SET_BUSINESS', response.business)
    return response.business
  },
  async getBusinesses (vuexContext, location) {
    vuexContext.commit('SET_LOADING_BUSINESSES', true)
    try {
      const response = await businessesService.getBusinesses(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.paginationBusinesses,
        vuexContext.state.search,
        vuexContext.state.advancedSearch,
        location || ''
      )
      vuexContext.commit('SET_TOTAL_BUSINESSES', response.businesses.count)
      vuexContext.commit('SET_BUSINESSES', response.businesses.rows)
      vuexContext.commit('SET_LOADING_BUSINESSES', false)
      return true
    } catch (error) {
      vuexContext.commit('SET_BUSINESSES', [])
      vuexContext.commit('SET_LOADING_BUSINESSES', false)
    }
  },
  async getContacts (vuexContext, businessId) {
    try {
      const response = await businessesService.getContacts(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        businessId)
      return response.users
    } catch (error) {
      vuexContext.commit('SET_BUSINESSES', [])
      vuexContext.commit('SET_LOADING_BUSINESSES', false)
    }
  },
  async importBusiness (vuexContext) {
    return await businessesService.uploadFile(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid, {
        file: vuexContext.rootState.listsPersons.importer.file,
        headers: vuexContext.rootState.listsPersons.importer.headers
      })
  },
  updateBusiness (vuexContext, data) {
    return businessesService.updateBusiness(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      data
    )
  },
  async deleteBusiness (vuexContext, businessId) {
    await businessesService.deleteBusiness(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      businessId
    )
    return true
  }
}

const getters = {
  categories: (state, getters, rootState, rootGetters) => {
    if (Array.isArray(rootGetters.selectedApp.extra_data) && rootGetters.selectedApp.extra_data.length > 0) {
      const categories = rootGetters.selectedApp.extra_data.find(dataItem => dataItem.field === 'categoriesLabels')
      if (categories && arraysAndJsonsHelpers.isJson(categories.value)) {
        return JSON.parse(categories.value).filter(item => !!item)
      } else {
        return []
      }
    }
    return []
  },
  segments (state, getters, rootState, rootGetters) {
    if (Array.isArray(rootGetters.selectedApp.extra_data) && rootGetters.selectedApp.extra_data.length > 0) {
      const segments = rootGetters.selectedApp.extra_data.find(dataItem => dataItem.field === 'segmentsLabels')
      if (segments && arraysAndJsonsHelpers.isJson(segments.value)) {
        return JSON.parse(segments.value).filter(item => !!item)
      } else {
        return []
      }
    }
    return []
  },
  otherLabels (state, getters, rootState, rootGetters) {
    if (Array.isArray(rootGetters.selectedApp.extra_data) && rootGetters.selectedApp.extra_data.length > 0) {
      const others = rootGetters.selectedApp.extra_data.find(dataItem => dataItem.field === 'othersLabels')
      if (others && arraysAndJsonsHelpers.isJson(others.value)) {
        return JSON.parse(others.value).filter(item => !!item)
      } else {
        return []
      }
    }
    return []
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
